module.exports = __webpack_public_path__ + "img/couverture.b863c588.png";